import { Logo } from "@/components/Logo";
import { AtmosphereLayer } from "@/components/appearance/AtmosphereLayer";

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="flex min-h-screen w-full">
      {/* left brand panel */}
      <div className="relative hidden w-1/2 flex-col justify-between overflow-hidden bg-sidebar bg-gradient-login p-12 lg:flex">
        <div className="absolute inset-0 sacred-bg opacity-[0.06]" />
        <AtmosphereLayer surface="login" slot="login_bg" overrideMode="dark" />
        <Logo onDark variant="login" size={48} />
        <div className="relative z-10 max-w-md">
          <h2 className="font-heading text-4xl font-semibold leading-tight text-sidebar-fg">
            The calm operating system for Nirvana's content.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-sidebar-fg/60">
            Plan, review and publish with authenticity — so nothing meaningful is ever forgotten.
          </p>
        </div>
        <p className="relative z-10 text-xs text-sidebar-fg/40">Invite-only access · Nirvana ContentOS</p>
      </div>

      {/* right form panel */}
      <div className="flex w-full flex-col items-center justify-center bg-background p-6 sm:p-10 lg:w-1/2">
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <Logo variant="login" />
          </div>
          <div className="mb-7">
            <h1 className="font-heading text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
